<div id="desktop-controller-place-holder">
   <div id="sidebar-container">
      <sidebar></sidebar>
   </div>
   <remote-feature></remote-feature>
   <html5-idle></html5-idle>
</div>
